import { createRouter, createWebHistory } from "@ionic/vue-router";
import store from "@/store";

const routes = [
  {
    path: "/",
    redirect: "/init",
  },
  {
    path: "/init",
    name: "Init",
    component: () => import("@/views/Init.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isInitialized = store.state.global.isInitialized;
  const isAuth = store.state.global.isAuth;

  let urlParams = new URLSearchParams(window.location.search);
  let params = null;
  if (urlParams.has("video")) {
    params = {
      video: urlParams.get("video"),
    };
  }

  if (isInitialized === false && to.name !== "Init") {
    next({ name: "Init", query: params });
  } else if (isInitialized === false && to.name === "Init") {
    next();
  } else if (to.name !== "Login" && isAuth === false) {
    next({ name: "Login", query: params });
  } else if (to.name === "Login" && isAuth === true) {
    next({ name: "Home", query: params });
  } else {
    next();
  }
});

export default router;
